import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { MarketplacePartnerRegisterPageFormInputField } from '../MarketplacePartnerRegisterPageFormInputField'

export const MarketplacePartnerRegisterPageFormBrandsEstimatedRevenue: FC =
  () => {
    return (
      <div className="flex flex-col gap-4">
        <div className="text-l">
          <FormattedMessage id="marketplacePartnerRegisterPage.brands.estimatedRevenue.input.description" />
        </div>
        <MarketplacePartnerRegisterPageFormInputField
          fieldName="estimatedRevenue"
          label={
            <FormattedMessage id="marketplacePartnerRegisterPage.brands.estimatedRevenue.input.label" />
          }
          required
          type="number"
        />
      </div>
    )
  }
